import { FC, ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Menu,
  MenuItem,
} from '@mui/material';

import markAnyLfsLogo from '@assets/images/markAnyLfsLogo.svg';
import Icon from 'shared/components/widgets/icon';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { isAdmin, isStaff } from '@utils/getRole';
import { useAuth } from 'contexts/authContext';

import DoneIcon from '@mui/icons-material/Done';
import { accountInfoDetailService } from '@services/private/account-info/account-info-detail';
import { getItem, setItem } from '@utils/localStorage';

const DashboardHeader: FC = (): ReactElement => {
  const [info, setInfo] = useState<any>(() => {
    const storedAccInfo = getItem('accountInfo')
    return storedAccInfo ?? null
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams()
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const getAccInfo = async () => {
      const res = await accountInfoDetailService()
      const data = res?.response?.result
      setInfo(data)
      setItem('accountInfo', data)
    }

    if (!info || searchParams.get('refetch')) {
      getAccInfo()
      searchParams.delete('refetch')
      setSearchParams(searchParams)
    }

  }, [info, searchParams]);

  return (

    <header>
      <Box
        display="flex"
        justifyContent="space-between"
        padding="10px 74px"
        bgcolor="var(--base-white)"
        borderBottom="1px solid var(--neutral-700)"
        height="60px"
      >
        <Box width={216} height={38}>
          <img
            src={markAnyLfsLogo}
            alt="MarkAny LFS"
            width={216}
            height={38}
            style={{ cursor: 'pointer' }}
            onClick={() => window.location.replace(ROUTES.CUSTOMER_DELIVERY_FILES.ROOT)}
          />
        </Box>
        <Box>
          <Button
            sx={{ textTransform: 'capitalize', gap: '24px', padding: 0 }}
            id="user-menu-button"
            aria-controls={open ? 'user-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="14px"
            >
              {
                isStaff
                  ?
                  <img
                    style={{ borderRadius: '50%' }}
                    width={42}
                    height={42}
                    src={info?.staffLoginInfo?.photoIconUrl}
                    alt={`${info?.staffLoginInfo?.userName}'s profile`}
                  />
                  : ''
              }
              {isStaff
                ? <Typography variant="body1" color="var(--base-black)"> {info?.staffLoginInfo?.userName} </Typography>
                : <Typography variant="body1" color="var(--base-black)" sx={{ paddingTop: '7px' }}> {info?.admDetail?.admName} </Typography>
              }
            </Box>
            <Icon name="drop_down_icon" size={24} color="var(--neutral-900)" />
          </Button>
          <Menu
            id="user-menu"
            aria-labelledby="user-menu-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {/* Information Inquiry */}
            <MenuItem
              sx={{ width: '180px' }}
              onClick={() => {
                handleClose();
                navigate(ROUTES.ACCOUNT_INFO.INFO_INQUIRY.path);
              }}
            >
              <Box display="flex" justifyContent="space-between" width="100%">
                <Typography>정보조회</Typography>
                {location.pathname === '/account-info/information-inquiry' && (
                  <DoneIcon sx={{ fontSize: '16px' }} />
                )}
              </Box>
            </MenuItem>
            {/* Change Password */}

            {isAdmin && (
              <MenuItem
                sx={{ width: '180px' }}
                onClick={() => {
                  handleClose();
                  navigate(ROUTES.ACCOUNT_INFO.CHANGE_PASSWORD.path);
                }}
              >
                <Box display="flex" justifyContent="space-between" width="100%">
                  <Typography>비밀번호 변경</Typography>
                  {location.pathname === '/account-info/change-password' && (
                    <DoneIcon sx={{ fontSize: '16px' }} />
                  )}
                </Box>
              </MenuItem>
            )}
            {/* Logout */}
            <MenuItem
              onClick={() => {
                handleClose();
                logout();
              }}
              sx={{ color: 'var(--danger-600)' }}
            >
              로그아웃
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </header>
  );
};

export default DashboardHeader;
